/* eslint-disable no-restricted-imports */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Warning as WarningIcon } from '@material-ui/icons';

export function CancelOrderDialog({ cancelDialogOpen, setCancelDialogOpen, handleCancel, order }) {
  const hasInvoices = order?.invoices && order.invoices.length > 0;
  const hasAuthorizedInvoices =
    hasInvoices &&
    order.invoices.some((inv) => inv.status === 'AUTHORIZED' || inv.status === 'PENDING');

  return (
    <Dialog open={cancelDialogOpen} onClose={() => setCancelDialogOpen(false)}>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <WarningIcon color='error' />
          Cancelar Pedido
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Tem certeza que deseja cancelar este pedido? Esta ação não poderá ser desfeita.
        </Typography>

        <Typography variant='body2' color='textSecondary' style={{ marginTop: 16 }}>
          <strong>O que será feito automaticamente:</strong>
        </Typography>
        <Typography component='div' variant='body2' color='textSecondary'>
          <ul style={{ marginTop: 8, paddingLeft: 20 }}>
            <li>O estoque atendido será devolvido aos locais de origem</li>
            <li>Todas as notas fiscais do pedido serão canceladas no sistema</li>
            <li>O pedido será marcado como CANCELADO</li>
          </ul>
        </Typography>

        {hasAuthorizedInvoices && (
          <Typography
            variant='body2'
            style={{ marginTop: 16, padding: 12, backgroundColor: '#FFF4E6', borderRadius: 4 }}
          >
            <strong style={{ color: '#E65100' }}>⚠️ IMPORTANTE:</strong>
            <br />
            Este pedido possui notas fiscais emitidas. Você deve{' '}
            <strong>cancelar manualmente todas as NFes no TinyERP</strong> antes de prosseguir com o
            cancelamento do pedido no sistema.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setCancelDialogOpen(false)}>Voltar</Button>
        <Button onClick={handleCancel} color='secondary' variant='contained'>
          Confirmar Cancelamento
        </Button>
      </DialogActions>
    </Dialog>
  );
}
